// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ms-common-error-container{min-height:2rem;height:100%;display:inline-block;width:100%}
`, "",{"version":3,"sources":["webpack://./src/components/shared/MSStatusWrappers/MSErrorStatus.scss"],"names":[],"mappings":"AAAA,2BACE,eAAgB,CAChB,WAAY,CACZ,oBAAqB,CACrB,UAAW","sourcesContent":[".ms-common-error-container {\n  min-height: 2rem;\n  height: 100%;\n  display: inline-block;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
